"use client";

import { isHeicImageSource } from "@/utils/heic-image";
import type { ImageProps } from "next/image";
import NextImage from "next/image";
import { useCallback, useState } from "react";
import { HeicImage } from "./HeicImage";

export function Image({ src: srcProp, ...props }: ImageProps) {
  const [failure, setFailure] = useState<{ source: string; terminal: boolean }>();
  const src = typeof srcProp === "string" ? srcProp.startsWith("src://") ? "https://iacgobig.com/wp-content/uploads/2019/07/placeholder.png" : srcProp : srcProp;
  const terminal = failure?.source === src && failure.terminal;
  const checkImage = useCallback((image: HTMLImageElement | null) => {
    if (!terminal && typeof src === "string" && src && image?.complete && image.currentSrc && image.naturalWidth === 0) setFailure({ source: src, terminal: false });
  }, [src, terminal]);
  const conversionFailed = useCallback(() => {
    if (typeof src === "string") setFailure({ source: src, terminal: true });
  }, [src]);
  const authenticatedFile = typeof src === "string" && src.startsWith("/api/application-files/");
  if (!terminal && typeof src === "string" && (isHeicImageSource(src) || failure?.source === src)) return <HeicImage {...props} src={src} onConversionError={props.onError || props.onErrorCapture ? conversionFailed : undefined} />;
  return (
    <NextImage
      src={src}
      {...props}
      ref={checkImage}
      unoptimized={authenticatedFile || props.unoptimized}
      onError={terminal || typeof src !== "string" || !src ? props.onError : undefined}
      onErrorCapture={event => {
        if (!terminal && typeof src === "string" && src) setFailure({ source: src, terminal: false });
        else props.onErrorCapture?.(event);
      }}
    />
  );
}
